import React from "react";
import {Button, Col, Form, Input, Row, Tabs, Typography} from "antd";
import {LockOutlined, UserOutlined} from '@ant-design/icons';
import img01 from "../../assets/img/login-img.png";
import {Link} from "react-router-dom";
import BaseComponent from "../../redare/components/BaseComponent";
import LoginPresenter from "../../.gen/presenter/LoginPresenter";
import Window from "../../redare/components/modal/Window";
import VerificationForm from "../../components/login/VerificationForm";
const {Title, Paragraph} = Typography;

export default class ChangePasswordPage extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {time:60};
        this.loginPresenter = new LoginPresenter(this);
    }

    _openVerifyImage(){
        let mobile = this.input.props.value;
        if (!mobile){
            this.toastFail("手机号码不能为空");
        }else {
            this._win = Window.show(
                <VerificationForm onCancel={() => {this._win.close();}}
                                  onSMSVCode={this._load.bind(this)}
                                  onCodeSuccess={this._onCodeSuccess.bind(this)}
                />,
                {title: '滑动验证'});
        }
    }

    _onCodeSuccess() {
        this._win.close();
    }

    _load(){
        let mobile = this.input.props.value;
        if (!mobile){
            this.toastFail("手机号码不能为空");
        }else {
            this.loginPresenter.checkPhoneNumExist({mobile},{},(result)=>{
                let user = result.data.user;
                if (user){
                    if (this.state.time<=0){
                        this.setState({time:60});
                    }
                    this.time();
                    this.setState({user});
                    this.loginPresenter.sendVerifyCode({mobile},{},(result)=>{
                        let resultData = result.data;
                        if (resultData){
                            this.setState({originalCode:resultData.verifyCode});
                            this._cleanVerifyCode();
                        }
                    })
                }
            })
        }

    }

    //3分钟后验证码失效
    _cleanVerifyCode(){
        setTimeout(() => {
            this.setState({originalCode:undefined});
        }, 180000);
    }

    time = () =>{
        clearInterval(this.timer);
        this.timer = setInterval(()=>{
            this.setState({time:this.state.time-1},()=>{
                if (this.state.time<=0){
                    clearInterval(this.timer);
                    return;
                }
                this.time();
            })
        },1000)
    };

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    _next(){
        this.formNext.validateFields().then(values => {
            let originalCode = this.state.originalCode;
            if (originalCode){
                if (values.verifyCode !== originalCode){
                    this.toastFail("验证码不正确,请重新输入！");
                }else {
                    this.props.history.push({ pathname: "/change/newPassword", state: { user:this.state.user} });
                }
            }else {
                this.toastFail("验证码失效，请重新发送验证码");
            }
        }).catch((e) => {});
    }


    render() {
        return (
            <div className="Login-Page">
                <div className="login-box bg-white">
                    <div className="pic">
                        <img className="" src={img01}/>
                    </div>
                    <div className="con">
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Row justify="center" className="logo">
                                    <Col>
                                        <h1>忘记密码</h1>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Form ref={(o) => this.formNext = o} className="login-form">
                                    <Form.Item name="mobile"  rules={[{required: true, message: '请输入手机号码！'}]}>
                                        <Input prefix={<UserOutlined className="site-form-item-icon"/>} ref={(input) => this.input = input} placeholder="请输入手机号码"/>
                                    </Form.Item>
                                    <Row gutter={8} justify="space-between">
                                        <Col>
                                            <Form.Item name="verifyCode" rules={[{required: true, message: '请输入短信验证码！'}]}>
                                                <Input
                                                    prefix={<LockOutlined className="site-form-item-icon"/>}
                                                    // className="ax_default shape"
                                                    placeholder="请输入短信验证码"
                                                />
                                            </Form.Item>

                                        </Col>
                                        <Col>
                                            <Form.Item>
                                                {(this.state.time <60 && this.state.time>0)?<Button type="primary" className="ax_default primary_button legacyPulsateBorder">
                                                    {this.state.time + 's'}
                                                </Button>:<Button type="primary" className="ax_default primary_button legacyPulsateBorder" onClick={()=>this._openVerifyImage()}>
                                                    发送验证码
                                                </Button>}
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" className="login-form-button"
                                                onClick={this._next.bind(this)}>
                                            下一步
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </Col>
                            <Col span={24}>
                                <div className="text-alignC">
                                    记起密码？<Link to="/login"> 立即登陆</Link>
                                </div>
                            </Col>
                        </Row>



                    </div>
                </div>
            </div>

        )
    }
}
